// src/pages/Payments/components/PaymentSummary.styles.ts
import styled from "styled-components";

export const FreeShippingBanner = styled.div<{ $achieved?: boolean }>`
  margin: 10px 14px 14px;
  padding: 12px 14px;
  border-radius: ${(p) => p.theme.tokens.radii.md}px;
  background: ${(p) => (p.$achieved ? p.theme.tokens.colors.softTeal : p.theme.tokens.colors.softBg)};
  color: ${(p) => (p.$achieved ? p.theme.tokens.colors.teal : p.theme.tokens.colors.ink)};
  font-family: ${(p) => p.theme.tokens.font.family};
  display: flex;
  flex-direction: column;
  gap: 2px;

  strong {
    font-size: 13.5px;
    font-weight: 900;
  }
  span {
    font-size: 12.5px;
  }
`;

export const Actions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 11px;
  margin: 4px 14px 24px;
`;

export const SpinnerWrap = styled.div`
  display: flex;
  justify-content: center;
  padding: 14px 0;
`;
